const chinese = {
  applicationName: '多米链钱包',
  unlockWallet: '解锁钱包',
  choosePassword: '选择密码',
  pickPassword: '设置一个密码来保护您的钱包（至少 12 个字符）。',
  passwordTooShort: '至少需要 12 个字符。',
  passwordMismatch: '两次输入的密码不一致。',
  skipPassword: '跳过（不设密码）',
  skipForNow: '暂时跳过',
  plaintextWarning: '不设置密码时，您的助记词将以未加密形式存储在此设备上。',
  noPasswordSet: '此钱包未设置密码。',
  secureWalletTitle: '保护您的钱包',
  secureWalletDescription:
    '此钱包未设置密码。请立即设置密码以在本设备上加密您的助记词。',
  secureWalletAction: '加密钱包',
  upgradePasswordTitle: '更新您的密码',
  upgradePasswordDescription:
    '您的钱包密码短于当前要求的最少 12 个字符。请设置一个新密码，以继续保护您的助记词。',
  updatePasswordAction: '更新密码',
  securingWallet: '正在保护钱包...',
  walletSecured: '钱包已保护',
  reenterPassword: '请重新输入密码以继续。',
  incorrectPassword: '密码错误。',
  enableAutoApproveTitle: '启用自动批准',
  enableAutoApproveWarning:
    '这将允许该网站在不每次询问的情况下发送交易。请输入密码以确认。',
  ifForgetPassword: '如果您忘记了密码，您将需要使用助记词来恢复您的钱包。',
  restoreExistingWallet: '恢复现有钱包',
  createNewWallet: '创建新钱包',
  createToHold: '创建一个新钱包来存放 Domichain 和 DPL 代币',
  seedSafePlace: '请写下以下十二个单词并妥善保管：',
  privateKeysStored:
    '您的私钥仅存储在您当前的计算机或设备上。如果您的浏览器存储被清除或者您的设备损坏或丢失，您将需要这些词来恢复您的钱包。',
  iHaveSaved: '我把这些话保存在一个安全的地方。',
  downloadMnemonic: '下载备份助记词文件（必填）',
  pleaseReenter: '请重新输入您的助记词以确认您已保存它。',
  pleaseType: '请输入您的助记词以确认',
  newPassword: '新密码',
  newPasswordOptional: '新密码（可选）',
  confirmPassword: '确认密码',
  back: '后退',
  createWallet: '创建钱包',
  unlockingWallet: '解锁钱包...',
  password: '密码',
  keepWalletUnlocked: '保持钱包解锁',
  restoreExisting: '恢复现有钱包',
  restoreUsing:
    '使用您的十二个或二十四个种子词恢复您的钱包。请注意，这将删除此设备上的所有现有钱包。',
  noHardwareWallet:
    '不要在此处输入您的硬件钱包助记词。创建网络钱包后，可以选择连接硬件钱包。',
  mnemonicFailed: '助记词验证失败。请输入有效的 BIP 39 助记词。',
  seedWords: '种子词',
  cancel: '取消',
  next: '下一个',
  addAccount: '新增帐户',
  name: '姓名',
  importPrivateKey: '导入私钥',
  pastePrivateKey: '导入私钥',
  add: '添加',
  close: '关闭',
  addCustomNetwork: '添加自定义网络',
  url: '网址',
  done: '完毕',
  continue: '继续',
  export: '出口',
  delete: '删除',
  send: '发送',
  receive: '收到',
  wrap: '包装',
  unwrap: '解包',
  wrapDomiTitle: '包装 DOMI',
  unwrapDomiTitle: '解包 wDOMI',
  wrapDomiInfo:
    '包装会将原生 DOMI 转换为 wDOMI 代币，可存入支持 DPL 代币的应用（如 FuFuture）。您可以随时解包换回原生 DOMI。',
  wrapUsdtTitle: '包装 USDT',
  wrapUsdtInfo:
    '包装会将旧版 USDT 按 1:1 转换为 wUSDT 代币。跨链桥会销毁交出的 USDT，并将等量的 wUSDT 铸造到您的钱包。',
  unwrapDomiInfo: '解包会将 wDOMI 转换回您主账户中的原生 DOMI。',
  unwrapDomiCloseNote: '解包全部余额将关闭 wDOMI 账户，并同时退还其租金押金。',
  wrapDomiConsolidateNote:
    '您现有的 wDOMI 也将转移到主（关联）代币账户；旧账户将被关闭并退还租金押金。',
  unlock: '开锁',
  confirmAddress: '确认您的钱包地址',
  checkLedger: '检查您的分类帐并确认显示的地址是您选择的地址。然后点击“完成”。',
  addHardwareWallet: '添加硬件钱包',
  connectLedger:
    '连接您的账本并打开 Domichain 应用程序。准备就绪后，单击“继续”。',
  loadingFromHardwareWallet: '从您的硬件钱包加载帐户',
  copied: '已复制',
  copyToClipboard: '复制到剪贴板',
  editAccountName: '修改账户名称',
  auxiliaruAccount: '这是一个辅助令牌帐户。',
  viewOnDomiexplorer: '在 Domiexplorer 上查看',
  viewDetails: '查看详情',
  tokenName: '代币名称',
  tokenSymbol: '代币符号',
  mainAccount: '主账户',
  account: '帐户',
  refresh: '刷新',
  wontRecover:
    '没有助记词和账户私钥，您将无法恢复当前账户。此操作将从您的浏览器中删除所有当前帐户。',
  perventLoss:
    '为防止资金损失，请确保您拥有所有活期账户的助记词和私钥。您可以通过在用户菜单中选择“导出助记词”来查看它。',
  enterSeedPhase: '请输入您的助记词以确认',
  deleteAndLogout: '删除助记词&退出',
  editAccount: '编辑帐户',
  addressReceive: '该地址可用于接收',
  depositAddress: '存款地址',
  enterDomichainAddress: '输入 Domichain 地址',
  enterDPLAddress: '输入 DPL 代币或 Domichain 地址',
  amount: '数量',
  max: '最大限度',
  recipientAddress: '收件人地址',
  use1: '请使用',
  use2: '虫洞传送桥',
  use3: '桥接您的资产。',
  save: '节省',
  exportAccount: '出口账户',
  privateKey: '私钥',
  reveal: '揭示',
  mnemonic: '助记词',
  connect: '连接',
  exportMnemonic: '导出助记词',
  importHardwareWallet: '进口硬件钱包',
  selectAccount: '选择账户',
  editCustomEndpoint: '编辑自定义端点',
  addCustomEndpoint: '添加自定义端点',
  hardwareWallet: '硬件钱包',
  selectNetwork: '选择网络',
  selectLanguage: '选择语言',
  connections: '连接',
  manageConnections: '管理连接',
  wallet: '钱包',
  walletBalance: '钱包余额',
  expandView: '展开视图',
  appName: 'DWallet',
  disconnect: '断开',
  connectedDapps: '连接的 Dapps',
  yourReferralLink: 'Your referral link',
  sendRequest: '发送请求',
  waitingForConfirmation: '等待确认中',
  withdrawFunds: '提款',
  deposit: '订金',
  metamaskConnected: '已连接元掩码',
  transactionPending: '待处理交易',
  language: '语言',
  confirmMnenonic: '确认助记词',
  creatingWallet: '创建钱包...',
  walletCreated: '钱包创建',
  time: '时间',
  txHash: '交易哈希',
  type: '类型',
  transfer: '转移',
  other: '其他',
  approve: '批准',
  deny: '拒绝',
  connectWalletDialogQuestion: '允许这个Dapp访问你的Domichain账户？',
  connectWalletDialogNotice:
    '只与你信任的网站连接。每笔交易都需要你批准；你可以在 "连接的Dapps" 部分为单个网站启用自动批准。',
  network: '网络',
  wantsToConnect: '请求连接到你的钱包',
  allowTransactionDialogQuestion: '允许这个Dapp发送一个交易？',
  airdrop: '空投',
  addressHasNoFunds: '该地址没有资金。你确定它是正确的吗？',
  mintNewToken: '铸造新令牌',
  mintNewTokenDescription:
    '生成并接收新的无价值令牌。此操作需要 DOMI 支付交易费用。',
  tokenDecimals: '代币小数',
  stake: '质押',
  delegate: '代表',
  yourStake: '您的质押',
  stakeAccount: '质押账户',
  status: '状态',
  balance: '余额',
  activeStake: '活跃质押',
  inactiveStake: '非活跃质押',
  reward: '奖励',
  unstake: '解除质押',
  claim: '宣称',
  availableForWithdraw: '现在可以提取的收益',
  totalRewardWithdrawn: '已经提取的收益',
  totalBalanceExpected: '解锁时将获得总数',
  withdrawStake: '提取质押资金',
  startStaking: '开始质押',
  stakingChoosePlanDescription:
    '通过选择下面的计划开始DOMI的质押，并获得奖励。',
  stakingDepositDescription:
    '将USDT存入BNB智能链上给定的存款地址，并指定令牌数量。\n\n一旦存款成功，您将自动符合进行质押的条件。',
  stakingDelegateDescription: '选择要与验证节点一起进行DOMI投票权委托的金额。',
  newStakingDelegateDescription1: '锁仓期： 将您的 $DOMI 锁仓 30 天。',
  newStakingDelegateDescription2: '总奖励：',
  newStakingDelegateDescription3: '现有 $DOMI：在质押期内获得 50% 的总回报。',
  newStakingDelegateDescription4: '新购买的 $DOMI：获得双倍奖励，总回报 100%。',
  newStakingDelegateDescription5: '每日提现：',
  newStakingDelegateDescription6:
    '现有 $DOMI：每天可以提取 0.2% 的收益到钱包或交易所（最低提现金额：10）。',
  newStakingDelegateDescription7: '新购买的 $DOMI：每天可以提取 0.47% 的收益。',
  newStakingDelegateDescription8: '',
  dailyWithdrawal: '每日提现',
  totalReward: '总奖励',
  stakeWarning:
    '您正在尝试质押超过已购买的 DOMI 数量，这意味着您将无法获得增加的奖励。请尝试减少质押数量或购买更多 DOMI。',
  purchase: {
    title: '购买',
    subtitle: '直接购买 DOMI 代币并通过质押开始赚取奖励。',
    afterPurchase: '购买后，您将立即获得：',
    dominPerUsdt: '每 2 USDT 获得 1 DOMI',
    sesaAirdrop: '消费最低 50 USDT 即可立即获得 2,000 SESA 代币',
  },
  newStakingMinDomiAmount: '最低金额：{0} DOMI',
  stakingActivatingDescription:
    '一旦费用账户激活，您所持有的DOMI将在三个小时以后开始赚取奖励。',
  stakingActiveDescription:
    '您当前正在与验证节点进行投票权委托。要使用这些资金，您需要解除投票权委托。',
  noStaking: '目前没有可用的质押计划',
  stakingPlan: '计划',
  stakingAnnualFee: '首年费用',
  stakingProduct: '产品',
  stakingAnnualRoi: '年回报率',
  stakingLimit: '限制',
  stakingUrl: '定标 URL',
  unlimited: '无限',
  validator: '验证节点',
  activating: '激活',
  active: '活跃',
  deactivating: '停用',
  inactive: '不活动',
  showDepositAddress: '支付',
  confirmUnstakeTitle: '确认解除抵押',
  confirmUnstakeDescription:
    '您确定要取消认购吗？您将停止赚取任何奖励，但可以提取您的资金。',
  installPwaTitle: '安装 DWallet',
  installPwaDescription: '在设备上安装该应用程序，即可随时轻松访问。',
  installPwaStepOne: '1. 点击 "分享" 按钮',
  installPwaStepTwo: '2. 选择 "添加到主屏幕"',
  installPwaStepThree: '3. 到主屏幕上，找到DWallet，点击DWallet。',
  redPacketTitle: '新年快乐！',
  redPacketAvailable: '点击这里领取你的免费红包礼物',
  redPacketUnavailable: '请在%s再来领取另一份礼物',
  redPacketSnackbar: '你已经从红包礼物中获得了%s个DOMI！',
  airdropIsAlreadyDoneToday: '今天的空投发完了，明天再来领取',
  errorOccurredTryAgainLater: '发生错误，请稍后重试',
  settings: '设置',
  free: '免费',
  welcomeAirdropTitle: '欢迎新用户!',
  welcomeAirdropAvailable: '按此获得我们赠送的 1 份免费 DOMI',
  welcomeAirdropUnavailable: '请在%s再来领取另一份礼物',
  welcomeAirdropSnackbar: '您已收到 %s DOMI 作为欢迎礼物！',
  usdtDepositNotice:
    '此地址只能用于接收来自 %s 的 USDT。请勿发送其他网络的代币! 收到 USDT 后，您可以使用它购买 DOMI 并获得 SESA 空投',
  usdtContractAddress: 'USDT 合约地址:',
  exchange: '交换',
  loading: '加载中...',
  expectedFee: '预计费用', // Expected fee N BTC
  youWillReceive: '您将收到', // You will receive N BTC
  selectTheFee: '选择费用',
  fastest: '最快的', // Fastest N sat/vB
  normal: '普通的', // Normal N sat/vB
  economy: '经济', // Economy N sat/vB
  sendingTransaction: '正在发送交易...',
  transactionConfirmed: '交易已确认',
  failedToSignAndSendAMultisigTransaction: '无法签署并发送多重签名交易',
  noAccountsFound: '未找到任何账户',
  requestFailed: '请求失败',
  noFeeRates: '无费率',
  insufficientFunds: '不充足的资金',
  tenMinutes: '~10分钟',
  thirtyMinutes: '~30分钟',
  oneHour: '~1小时',
  buyDomiItemTitle: '购买 DOMI',
  buyDomiItemSubtitle: '存入USDT购买DOMI',
  buyDomiButton: '购买 DOMI',
  buyDomiDialogTitle: '购买 DOMI',
  buyDomiMinimumUsdtAmount: '最低 USDT 金额：{0} USDT',
  buyDomiReceiveNotice: '兑换后，您的钱包马上会获得相应的DOMI。',
  buyButton: '买',
  telegramSubscriptionTitle: '订阅我们的社交网络',
  telegramSubscriptionLink: '点击在 Telegram 中打开',
  telegramSubscriptionLink2: '电报社区链接：',
  telegramInstructions1: '如果您没有 Telegram：',
  telegramInstructions2: '在您的设备上安装 Telegram',
  telegramInstructions3: '或使用其他装有 Telegram 的设备扫描二维码',
  telegramInstructions4: '点击链接或在浏览器中打开',
  telegramInstructions5: '按"开始"按钮开始与我们的 Telegram 机器人聊天',
  telegramInstructions6: '按照我们机器人的指示加入我们的 Telegram 社区',
  telegramInstructions7: '返回 DWallet 并按"继续"按钮',
  subscribeTwitterInstructions: '在 Twitter 上关注我们的社区：',
  twitterSubscriptionLink: '点击此处在 Twitter 上打开，然后点击“关注”按钮',
  referral: {
    title: '转介',
    description: '推荐朋友获得更多奖励！',
    totalReferral: '您的总推荐',
    referralReward: '您的{coin}推荐奖励',
    pendingReward: '待定{coin}奖励',
    claim: '领取推荐奖励',
    copy: '复制',
    referralLinkLabel: '推荐链接',
    referralLinkLoading: '正在加载推荐链接...',
    guide1: '1. 将您的推荐链接发送给您的朋友。',
    guide2: '2. 当他们下注时，您可以获得额外的奖励。',
    earningByLevels: '获得 1-10% 的推荐奖励',
    teamRewardsByLevels: '团队奖金',
    updateHeader: '更新您的信息',
    update: '更新',
  },
  referralTable: {
    date: '日期',
    event: '事件',
    walletId: '钱包 ID',
    stakeAmount: '质押数量',
    registered: '已注册',
    bonusDomi: '奖励 {0} DOMI',
    domi: '{0} DOMI',
  },
  minerStakingDescription:
    '选择适合您投资策略的矿机。每个计划提供不同的奖励和条款。',
  price: '价格',
  stakeRequired: '所需股份：',
  dailyReward: '每日奖励： ',
  totalReward: '总奖励：',
  totalReturn: '总回报：',
  minStake: '最低投注额：',
  maxStake: '最大赌注： ',
  reqLock: '需要锁定：',
  period: '时期：',
  buyNow: '立即购买',
  orderSummary: '订单摘要',
  insufficientBalance: '本次购买余额不足',
  shipping: '运输信息',
  name: '姓名',
  email: '电子邮件',
  number: '电话号码',
  address: '地址',
  city: '城市',
  country: '国家',
  postal: '邮政编码',
  notes: '附加说明',
  buyAI: '购买人工智能矿机',
  buyAIMSG: '购买矿机并赚取奖励',
  lockPeriod: '释放时间',
  reqStake: '需要质押',
  miningM: '服务器型号: ',
  orderCon: '订单确认',
  orderThx: '感谢您的订购！您的采矿机 {} 已成功购买。',
  orderProcess: '我们将处理您的订单并通过以下方式联系您 {} 以及交货详细信息。',
  orderDate: '订购日期：',
  orderTotal: '总付费：',
  apiSendFail:
    '您的付款已成功处理，但我们无法通知我们的服务器有关您的订单详细信息。这不会影响您的购买，但请点击“重试”以确保我们拥有您的送货信息。',
  yourAiNodeStake: '您的 AI 节点权益',
  deactiveStakeWarning: '警告：此质押已停用，无法获得奖励。请重新激活。',
  humanVerification: '需要人工验证',
  verificationSuccess: '✓ 验证成功！',
  verificationSuccess2: '您已被验证为人类用户。',
  pleaseVerifyMsg: '请输入以下字符来验证您是人类：',
  refreshCaptcha: '刷新验证码',
  enterChar: '输入上面的字符',
  enterChar2: '请输入正确的字符',
  fufutureItemTitle: 'FuFuture DEX',
  fufutureItemSubtitle: '在 FuFuture 平台交易去中心化期权',
  skip: '跳过',
  skipBackupTitle: '暂时跳过备份？',
  skipBackupDescription:
    '您可以稍后随时在账户菜单的"%s"中查看并备份助记词。在完成备份之前，如果设备丢失或数据被清除，您将无法恢复钱包。',
  tokenStaking: {
    sectionTitle: '代币质押',
    stakeTitle: '质押',
    apr: '年化',
    dayLock: '天锁定',
    minimum: '最低',
    projected: '预计收益',
    lockedUntil: '锁定至',
    unlocked: '已解锁',
    claimable: '可领取',
    claimed: '已领取',
    staked: '已质押',
    unstaked: '已解除质押',
    addMore: '追加',
    back: '返回',
    confirmStake: '确认质押',
    sending: '发送中…',
    paused: '已暂停',
    free: '可用奖励',
    daysRunway: '天奖励储备',
    poolHealth: '池',
    noPools: '您的代币暂无可用质押池。',
    noBalance: '您没有可质押的 %s，请先在市场购买。',
    insufficientBalance: '余额不足',
    topUpRelocks: '追加质押将把您现有的 %s 重新锁定完整锁定期。',
    unstakeHint: '留空则全部提取。',
    remainderBelowMinimum: '剩余质押必须为 0 或至少',
    rewardsPaidWithUnstake: '累计奖励将随本次提取一并发放。',
    rewardsStayClaimable: '奖励池目前无法支付累计奖励，奖励仍可稍后领取。',
    rewardsPendingFunding: '本金已提取。奖励池补充后即可领取奖励。',
    errPaused: '该代币的质押已暂停',
    errBelowMinimum: '低于最低质押数量',
    errCapExceeded: '质押池已满',
    errRewardsUnderfunded: '质押池暂时无法为该数量预留奖励',
    errNoPosition: '没有质押仓位',
    errLocked: '仓位仍在锁定中',
    errNothingToClaim: '没有可领取的奖励',
    errInsufficientRewardVault: '奖励池无法支付本次领取',
    errExceedsPrincipal: '数量超过已质押余额',
    errProgram: '质押程序错误',
  },
  domiHealth: {
    sectionTitle: 'DomiHealth',
    notPairedTitle: '尚未与边缘节点配对',
    notPairedDescription: '扫描您的 DomiHealth 边缘节点显示的配对二维码，将此钱包与其连接。',
    pairButton: '扫描配对码',
    pairDialogTitle: '与边缘节点配对',
    scanQrButton: '扫描二维码',
    pastePairingCodeLabel: '或粘贴配对 JSON',
    pairingInvalid: '该配对码无效。',
    forgetEdgeNodeButton: '忘记此边缘节点',
    forgetEdgeNodeConfirm: '要忘记此边缘节点吗？您需要重新扫描其配对码才能重新连接。',
    pairedWith: '已与 {0} 配对',
    unlockTitle: '解锁您的健康数据',
    autoUnlocking: '正在使用您的钱包解锁…',
    passphraseFallbackHint: '此账户在自动解锁功能上线之前创建——请输入您最初设置的密码。',
    passphraseLabel: '本地密码',
    passphraseHint: '这是您在此边缘节点上数据的独立密码——并非您的钱包密码。',
    unlockButton: '解锁',
    incorrectPassphrase: '密码错误。',
    lockButton: '锁定',
    recordsTitle: '健康记录',
    noRecords: '暂无记录。',
    addMeasurementButton: '添加测量值',
    addMeasurementTitle: '添加测量值',
    metricTypeLabel: '指标（例如 heart_rate、weight）',
    valueLabel: '数值',
    unitLabel: '单位（可选）',
    saveButton: '保存',
    documentTypeLabel: '您要上传的是什么？',
    documentTypeLab: '化验报告',
    documentTypeGrocery: '购物小票',
    documentTypeRestaurant: '餐厅小票',
    uploadPhotoButton: '拍照（例如化验结果）',
    uploadingPhoto: '正在上传…',
    uploadFromStorageButton: '从存储中选择文件（照片或 PDF）',
    uploadingFile: '正在上传…',
    documentUploaded: '已上传——正在后台提取化验结果。请稍后回到此处查看。',
    groceryReceiptUploaded: '已上传——正在后台提取购物项目。请稍后回到此处查看。',
    restaurantReceiptUploaded: '已上传——正在后台提取点餐项目。请稍后回到此处查看。',
    documentAlreadyUploaded: '此文件已经上传过——未添加任何新内容。',
    cameraError: '无法拍照。',
    filePickerError: '无法选择或上传该文件。',
    genericError: '与边缘节点通信时出错：{0}',
    insecureConnectionNotice: '此连接尚未验证边缘节点的证书——请仅在您信任的网络中使用。',
    claimRewardsButton: '领取 DHT 奖励',
    claimingRewards: '正在构建并提交领取请求…',
    noClaimsAvailable: '目前没有可领取的奖励。',
    claimsSubmitted: '已提交 {0} 项奖励领取请求。',
    claimsSkipped: '已跳过 {0} 条记录：{1}',
    claimFailed: '一项领取请求失败：{0}',
    backupButton: '备份我的数据',
    backingUp: '正在备份…',
    backupComplete: '备份已创建，链上指针已更新。',
    restoreButton: '从备份恢复',
    restoring: '正在恢复…',
    restoreComplete: '已从备份恢复 {0} 条记录。',
    restoreNoBackupFound: '未找到此钱包的备份。',
    deregisterSectionTitle: '边缘节点丢失了？',
    deregisterSectionDescription:
      '如果您的边缘节点丢失、被盗或已更换，请释放其设备名额，以便注册新设备。您需要该设备的公钥——它会在设备首次启动时打印在其终端/控制台上（"Device identity: ..."）。此操作可以使用您当前配对的任意边缘节点完成，无需使用丢失的那台。',
    devicePubkeyLabel: '丢失设备的公钥',
    deregisterButton: '解除丢失设备的注册',
    deregistering: '正在解除注册…',
    deregisterComplete: '设备已解除注册——其名额现已释放。',
    anchoredChip: '已锚定',
    pendingChip: '待处理',
    wellnessAnalysisTitle: '健康总结',
    chatSectionTitle: '健康问答',
    chatSectionDescription: '通过打字向健康助手提问，而不是说话——运行方式与语音助手相同，均在您的边缘节点上进行。',
    chatInputLabel: '输入您的健康问题',
    chatSendButton: '发送',
    chatYouLabel: '您',
    chatAssistantLabel: '助手',
    voiceSectionTitle: '语音助手',
    voiceSectionDescription: '语音转文字和文字转语音均在您的边缘节点上运行，而非您的手机或云端——您的语音不会离开本地网络。',
    startRecordingButton: '开始录音',
    stopRecordingButton: '停止录音',
    askAssistantButton: '询问健康助手',
    saveAsNoteButton: '保存为语音笔记',
    processingVoice: '正在处理…',
    voiceTranscriptLabel: '您说',
    voiceResponseLabel: '助手',
    voiceNoteTranscribed: '已转录——请在下方查看并点击保存。',
    voiceNativeOnly: '语音录制目前不可用。',
    dashboardSectionTitle: '健康仪表盘',
    dashboardNoFlaggedItems: '目前没有超出正常范围的项目。',
    dashboardFlaggedItemsCount: '{0} 项超出正常范围',
    dashboardRefreshButton: '刷新',
    dashboardAskAboutButton: '询问此项',
    askAboutItemQuestion: '我的{0}检测结果为 {1} {2}，超出了正常范围。这意味着什么？有哪些生活方式的调整可能有帮助，或者我需要看医生吗？',
    dashboardAsking: '正在询问…',
    dashboardTypicalRangeLabel: '正常范围',
    patientInfoLabel: '患者',
    reportDateLabel: '报告日期',
    purchaseDateLabel: '购买日期',
    processingDocument: '正在后台提取化验结果——请稍后回来查看',
    labValuesLabel: '化验数值',
    labValuesCount: '已记录 {0} 项化验数值',
    groceryItemsCount: '已记录 {0} 项购物商品',
    restaurantItemsCount: '已记录 {0} 项点餐项目',
    viewerUploadedAtLabel: '上传时间',
    viewerPreviewUnavailable: '此文件类型（{0}）暂不支持预览。请使用下载功能将其保存到您的设备。',
    viewerCloseButton: '关闭',
    viewerDownloadButton: '下载',
    viewerDownloading: '正在下载…',
    viewerDownloadComplete: '已将 "{0}" 保存到您的下载文件夹。',
    viewerDownloadFailed: '无法下载此文件。',
  },
};

export default chinese;
